import { createSlice, createSelector } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  startValue: null,
  endValue: null,
  onDateRangePicked: false,
  onParameterPicked: false,
  searchWasMade: false,
  value: "",
  type: "shipmentCode",
  shipmentCode: null,
  imei: null,
  numRefClient: null,
  clientNumber: null,
  labellerCode: null,
  boxType: [],
  temperatureTrazability: [],
  temperatureRange: [],
  page: 1,
  size: 10,
};

const homeSearchSlice = createSlice({
  name: "homeSearch",
  initialState,
  reducers: {
    setSearchParameters: (state, action) => ({ ...state, ...action.payload }),
    clearSearchParameters: () => ({ ...initialState }),
    toggleAdvancedSearch: (state, action) => {
      const show = action.payload;
      if (show) {
        state.startValue = moment().add(-7, "days").toISOString();
        state.endValue = moment().toISOString();
      } else {
        state.startValue = null;
        state.endValue = null;
      }
    },
    setHomePagination: (state, action) => {
      const { page, size } = action.payload || {};
      if (page !== undefined) state.page = page;
      if (size !== undefined) state.size = size;
    },
  },
});

export const {
  setSearchParameters,
  clearSearchParameters,
  toggleAdvancedSearch,
  setHomePagination,
} = homeSearchSlice.actions;

export const selectHomeSearch = (state) => state.homeSearch;

const criteria = [
  "value",
  "shipmentCode",
  "imei",
  "numRefClient",
  "startValue",
  "endValue",
  "clientNumber",
  "labellerCode",
  "boxType",
  "temperatureTrazability",
  "temperatureRange",
];

const isFilled = (value) =>
  Array.isArray(value)
    ? value.length > 0
    : typeof value === "string"
    ? value.trim() !== ""
    : value != null;

export const selectHasCriteria = createSelector([selectHomeSearch], (s) =>
  criteria.some((key) => isFilled(s[key]))
);

export default homeSearchSlice.reducer;
